import { Box, Button, Modal, ModalProps } from '@palmetto/palmetto-components';

export interface VoidContractModalProps extends ModalProps {
  onCreateChangeOrder: () => void;
  onConfirmVoid: () => void;
  isVoiding: boolean;
  canCreateChangeOrder?: boolean;
  willVoidPreBillingDiscountAmendment?: boolean;
}

/**
 * Shown before voiding a contract on a Change-Order-eligible program type, giving the
 * EPC a chance to create a Change Order instead of voiding outright.
 */
export function VoidContractModal({
  isOpen,
  isVoiding,
  onDismiss,
  onCreateChangeOrder,
  onConfirmVoid,
  canCreateChangeOrder,
  willVoidPreBillingDiscountAmendment,
}: VoidContractModalProps) {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxWidth="4xl" ariaLabelledBy="isVoidingRequired" fullScreenMobile>
      <Modal.Header id="isVoidingRequired" title="Is Voiding Required?" onDismiss={onDismiss} />
      <Modal.Body background="secondary" childGap="lg">
        <Box fontSize={'sm'} color="body-primary" data-testid="void-contract-modal-body">
          If you need to change system size, escalation rate, adders, or pricing, you may be able to do a change
          order instead.
          {willVoidPreBillingDiscountAmendment && (
            <>
              <br />
              <br />
              Voiding this contract will also void the pre-billing discount amendment.
            </>
          )}
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Box justifyContent={'space-between'} display={'flex'} direction={'row'} width={'100'}>
          <Button
            variant="secondary"
            tone="neutral"
            size="md"
            disabled={isVoiding}
            onClick={onDismiss}
            data-testid="void-contract-modal-cancel-cta"
          >
            Cancel
          </Button>
          <Box display={'flex'} direction={'row'} childGap="sm">
            {canCreateChangeOrder && (
              <Button
                variant="secondary"
                tone="primary"
                size="md"
                disabled={isVoiding}
                onClick={onCreateChangeOrder}
                data-testid="void-contract-modal-create-change-order-cta"
              >
                Create Change Order
              </Button>
            )}
            <Button
              variant="primary"
              tone="danger"
              size="md"
              isLoading={isVoiding}
              onClick={onConfirmVoid}
              data-testid="void-contract-modal-confirm-void-cta"
            >
              Confirm Void
            </Button>
          </Box>
        </Box>
      </Modal.Footer>
    </Modal>
  );
}
